import React, { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Homescreen } from '../screens/Homescreen'
import { Liquidaciones } from '../screens/Liquidaciones'
import { Licencias } from '../screens/Licencias'
import { Certificados } from '../screens/Certificados'
import { Contrato } from '../screens/Contrato'
import { Datos } from '../screens/Datos'
import { Vacaciones } from '../screens/Vacaciones/Vacaciones'
import { NavBar } from '../components/NavBar'
import { ChangePass } from '../screens/CambiarDatos/ChangePass'
import { ChangeEmail } from '../screens/CambiarDatos/ChangeEmail'
import { SideBar } from '../components/SideBar'
import { IndexFirma } from '../screens/firma/IndexFirma'
import { VerPdf } from '../screens/firma/VerPdf'
import fondoSVG from '../assets/background.svg'
import { SolicitarVacaciones } from '../screens/Vacaciones/SolicitarVacaciones'

export const NavigationLog = () => {



  return (
    
    <>
    
    
    <div className='contenedor' >

      {
        window.innerWidth >= 771  ? <SideBar/> : <NavBar/>
      }

      

      <div style={{ backgroundImage: `url(${fondoSVG})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom' }} className="contenedorContenido">

      <Routes>

     



              <Route path='/home' element={<Homescreen />} />
              <Route path='/liquidaciones' element={<Liquidaciones />} />
              <Route path='/licencias' element={<Licencias />} />
              <Route path='/certificados' element={<Certificados />} />
              <Route path='/contrato' element={<Contrato />} />
              <Route path='/datos' element={<Datos />} />
              
              <Route path='/vacaciones' element={<Vacaciones />} />
      

              <Route path='/solicitar-vacaciones' element={<SolicitarVacaciones />} />
           
              <Route path='/cambiarClave' element={<ChangePass />} />
              <Route path='/cambiarEmail' element={<ChangeEmail />} />
              <Route path='/firmaDigital' element={<IndexFirma />} />

              

              <Route
              path="*"
              element={<Navigate to="/" replace />}
              />



        </Routes>


      </div>

  


    </div>

    
    
    

    
    </>
    
    
   
  )
}
